/**
 * Canonical error messages thrown when a deck yields no extractable text.
 * Centralised here so pdf.ts, pptx.ts, and shared.ts all match the same
 * strings — a copy that drifts silently breaks isDeckNoTextError.
 */

export const PDF_NO_TEXT_ERROR = "No text could be extracted from the PDF";

/** Thrown when a PPTX contains no text-bearing slides or no slides at all. */
export const PPTX_NO_TEXT_ERROR = "No text could be extracted from the PPTX";
export const PPTX_NO_SLIDES_ERROR = "No slides were found in the PPTX";

/** Thrown by parseDocxToText when a DOCX holds no readable text. */
export const DOCX_NO_TEXT_ERROR = "No text could be extracted from the DOCX";
